import styled from 'styled-components';

import Picture from 'components/picture';

const BackgroundPicture = styled(Picture)``;

export default BackgroundPicture;
